const getters = {
    getVisible(state) {
        return state.show;
    },
    getEvents(state) {
        return state.events;
    },
    getErrors(state) {
        return state.errors;
    },
    getIsShouldBeCleared(state) {
        return state.isShouldBeCleared;
    },
};

const actions = {
    setShow({ commit }, date) {
        commit("setShow", date);
    },
    setEvents({ commit }, date) {
        commit("setEvents", date);
    },
    setIsShouldBeCleared({ commit }, value) {
        commit("setIsShouldBeCleared", value);
    },
    setErrors({ commit }, value) {
        commit("setErrors", value);
    },
    clearEvents({ commit }) {
        commit("clearEvents");
    },
    clearErrors({ commit }) {
        commit("clearErrors");
    },
};

const mutations = {
    setShow(state, data) {
        state.show = data;
    },
    setEvents(state, data) {
        state.events = {
            room: data.room,
            events: data.events,
            teachers: data.teachers,
            students: data.students,
            end_datetime: data.end_datetime,
            noActiveTeachers: data.noActiveTeachers,
            noActiveStudents: data.noActiveStudents,
            max_reservation_days: data.max_reservation_days,
        };
    },
    setErrors(state, errors) {
        state.errors = errors || {};

        state.errors.emptyStudentGroup = !!Object.keys(errors || {}).find((err) =>
            err.startsWith("students.")
        );
    },
    setIsShouldBeCleared(state, value) {
        state.isShouldBeCleared = value;
    },
    clearEvents(state) {
        state.events = {
            room: "",
            teachers: null,
            students: null,
            events: null,
            end_datetime: [],
        };
    },
    clearErrors(state) {
        state.errors = {
            teachers: null,
            students: null,
            subject_id: null,
        };
    },
};

const state = {
    show: false,
    isShouldBeCleared: false,
    events: {
        room: "",
        teachers: null,
        students: null,
        end_datetime: [],
    },
    errors: {
        teachers: null,
        students: null,
        subject_id: null,
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
